import styled from "styled-components";
import { theme } from "styles/theme";

export const ChartsContainer = styled.div`
  margin-top: 1rem;
`;

export const ChartGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 1.5rem;
  padding: 0.5rem 0;

  @media (max-width: ${theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  @media (min-width: ${theme.breakpoints.desktop}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 1600px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const ChartCard = styled.div`
  background-color: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
  overflow: visible;
  height: 100%;
  margin-bottom: 1.5rem;
`;

export const ChartContainer = styled.div`
  padding: 0;
  height: 320px;
  position: relative;
  overflow: visible;
`;

export const NoDataMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 1rem;
  color: ${theme.colors.textSecondary};
  text-align: center;
  padding: 1rem;
`;
